import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
  MatButtonModule, MatInputModule, MatCardModule, MatToolbarModule, MatMenuModule, MatIconModule, MatSidenavModule,
  MatCheckboxModule, MatTabsModule, MatSelectModule, MatAutocompleteModule, MatListModule, MatTableModule, MatSortModule,
  MatPaginatorModule, MatProgressSpinnerModule, MatDatepickerModule, MatExpansionModule, MatDialogModule, MatTooltipModule,
  MatSlideToggleModule
} from '@angular/material';
import { MyDateRangePickerModule } from 'mydaterangepicker';
import { ToasterModule } from 'angular2-toaster';

import { ActivityComponent } from './components/Activity/activity.component';
import { VehicleFilterSidebarComponent } from './components/vehicle-file-sidebar/vehicle-file-sidebar';
import { InvestigationComponent } from './components/Investigation/investigation.component';

import { SharedModule } from '../shared/shared.module';
import { ToasterErrorService } from '../_services/toaster.service';
import { EventsService } from '../_services/events.service';



// Routingmodule
import { VehicleFileRoutes } from './vehicle-file.routes';

@NgModule({
  imports: [
    FormsModule,
    RouterModule,
    CommonModule,
    SharedModule,
    MatMenuModule,
    MatIconModule,
    MatTabsModule,
    MatListModule,
    MatSortModule,
    MatTableModule,
    MatInputModule,
    MatSelectModule,
    MatButtonModule,
    MatDialogModule,
    MatToolbarModule,
    MatSidenavModule,
    MatTooltipModule,
    MatCheckboxModule,
    MatPaginatorModule,
    MatExpansionModule,
    MatDatepickerModule,
    MatSlideToggleModule,
    MatAutocompleteModule,
    MatProgressSpinnerModule,
    ToasterModule,
    ReactiveFormsModule,
    MyDateRangePickerModule,
    VehicleFileRoutes
  ],

  providers: [
    ToasterErrorService,
    EventsService
  ],
  declarations: [
    // Components
    ActivityComponent,
    VehicleFilterSidebarComponent,
    InvestigationComponent
  ],

  exports: [
    // Components
    ActivityComponent,
    VehicleFilterSidebarComponent,
    // Modules
    FormsModule,
    RouterModule,
  ]

})
export class VehicleFileModule {
  constructor() {
  }
}



// WEBPACK FOOTER //
// /Users/brianyoung/Documents/Development/hfg/datalive-core/gae-web/datalive/client/src/app/Vehicle-file/vehicle-file.module.ts